module.exports = __webpack_public_path__ + "img/soft-skills-image-3.671214b2.jpg";